import axiosInstance from "../../app/apiClient";
export const getLoggingOrder = (filter: any) => axiosInstance.get(`/api/v1/logging/order${filter}`)
export const getLoggingPayment = (filter: any) => axiosInstance.get(`/api/v1/logging/paymentResult${filter}`)

